import React, { useCallback } from "react";
import { Dialog } from "components/main/utils/Dialog";
import { MyModelsTab } from "./ownership/MyModelsTab";

interface OwnershipTransferModalProps {
  currentModelId: string | undefined;
  tableId: string;
  tableName: string;
  /// Composed FGA `can_transfer = owner from parent and can_propagate from
  /// parent_connection`, hydrated server-side. Only the catalog destination
  /// needs it: entering the catalog crosses from user-owned into role-owned,
  /// publishable space, so a connector-driven table is refused there with 403
  /// `table_locked_to_parent`. A move between the caller's own models is not
  /// gated by it.
  canTransferTable: boolean;
  /// Whether the table's current model is a catalog model. A catalog table can
  /// only move to another catalog model, so this picks the destination list.
  currentModelIsCatalog: boolean;
  open: boolean;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
}

/// D42 retired cross-user transfer: a table moves between MODELS, never between
/// people. Handing work to someone else is a space grant (the manager set owns
/// every model in the space), and rescuing a departing user's tables is the
/// account-deletion copy window — neither needs an offer protocol.
export const OwnershipTransferModal = ({
  currentModelId,
  tableId,
  tableName,
  canTransferTable,
  currentModelIsCatalog,
  open,
  onOpenChange,
}: OwnershipTransferModalProps) => {
  const handleClose = useCallback(() => onOpenChange(false), [onOpenChange]);

  return (
    <Dialog
      open={open}
      title="Move table to another model"
      onClose={handleClose}
      autoSpacing={false}
    >
      <div className="flex flex-col w-full overflow-visible">
        <MyModelsTab
          currentModelId={currentModelId}
          currentModelIsCatalog={currentModelIsCatalog}
          canEnterCatalog={canTransferTable}
          tableId={tableId}
          tableName={tableName}
          open={open}
          onClose={handleClose}
        />
      </div>
    </Dialog>
  );
};
